import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Route,
  withRouter,
  Switch,
  Router,
  Redirect,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import Login from "../Login";
import ForgotUserID from "../ForgotUserID";
import ReceivedUserID from "../ForgotUserID/components/ReceivedUserID";
import ForgotPassword from "../ForgotPassword";
import NewPassword from "../ForgotPassword/components/NewPassword";
import ChangedPassword from "../ForgotPassword/components/ChangedPassword";
import Registration from "../Registration";
import MobileVerification from "../Registration/components/MobileVerification";
import OnlineRenewal from "../OnlineRenewal";
import CheckRewability from "../OnlineRenewal/components/CheckRewability";
import PolicyInfo from "../OnlineRenewal/components/PolicyInfo";
//import PolicyInfo from "../OnlineRenewal/components/PolicyInfoNewV";
import RenewalUnsuccessful from "../OnlineRenewal/components/RenewalUnsuccessful";
import PaymentResult from "../OnlineRenewal/components/PaymentStatus";
import Footer from "../../components/Footer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Image from "../../../assets";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ForgotUserIdOtp from "../OTP/components/ForgotUserIdOtp";
import ForgotUserPassOtp from "../OTP/components/ForgotUserPassOtp";
import RegistrationOtp from "../OTP/components/RegistrationOtp";
import AuthorizationMaybank from "../AuthorizationMaybank";
import ActivationGenericLink from "../ActivationLink/components/genericLink";
import ActivationPersonalLink from "../ActivationLink/components/personalLink";
import ActivationGenericOtpVerify from "../ActivationLink/components/genericOtpVerify";
import ActivationPersonalOtpVerify from "../ActivationLink/components/personalOtpVerify";
import ReceivedGenericLinkOtp from "../ActivationLink/components/receivedGenericLinkOtp";
import ReceivedPersoanlLinkOtp from "../ActivationLink/components/receivedPersonalLinkOtp";
import Registrationv1 from "../Registrationv1";
import AccountExist from "../Registration/components/AccountExist";
import MobileNoRequired from "../Registration/components/MobileNoRequired";
import CustomBoard from "../../components/CustomBoard";
import SingpassRedirectPage from "../SingpassRedirectPage";
import PayRenewalUnsuccessful from "../OnlineRenewal/components/PayRenewalFailed";
import EnrolGiroNow from "../EnrolGiroNow";
import EnrolGiroInfo from "../EnrolGiroNow/PolicyInfo";
import SelectEnrolmentAccount from "../EnrolGiroNow/SelectEnrolmentAccount";
import EnrolmentStatus from "../EnrolGiroNow/EnrolmentStatus";
import DDAResponseStatus from "../EnrolGiroNow/DDAResponseStatus";
import AuthManager from "../../../utils/AuthManager";
import FileManager from "../FileManager";
import GiroProcess from "../EnrolGiroNow/GiroProcess";
import DDAMissMatch from "../EnrolGiroNow/DDAMissMatch";
import DDAMissMatchNo from "../EnrolGiroNow/DDAMissMatchNo";
import DDAMissMatchYes from "../EnrolGiroNow/DDAMissMatchYes";
import GiroReview from "../EnrolGiroNow/GiroReview";
import ProcessSubmitStatus from "../EnrolGiroNow/ProcessSubmitStatus";
import ReactGA from "react-ga";
import LiveChat from "../LiveChat";
import MovieEvent from "../MovieEvent";
import FooterMovieEvent from "../../components/FooterMovieEvent";
import { version, dependencies } from '../../../../package.json';
import SingtelLeads from "../SingtelLeads";
import WalkAndWag from "../WalkAndWag";
import LandingPage from "../LandingPage";
import OnboardingFlow from "../OnboardingFlow";
import RetrieveOptionFir from "../OnboardingFlow/retrieveOptionFir";
import MobileOtp from "../OnboardingFlow/mobileOtp";
import NormalReg from "../OnboardingFlow/NormalReg";
import SPLanding from "../OnboardingFlow/SPLanding";
import PolicyRedirection from "../PolicyRedirection";
import NormalRegNew from "../OnboardingFlow/normalRegNew";
import IdentityVerification from "../OnboardingFlow/OCR";
import MobileOtpNew from "../OnboardingFlow/mobilleOtpNew";
import ReceivedRequest from "../OnboardingFlow/ReceivedRequest";
import SomethingWrong from "../OnboardingFlow/SomethingWrong";
import CreateUserIDPass from "../OnboardingFlow/CreateUserIDPass";
import ExistingAcc from "../OnboardingFlow/ExistingAcc";
import LoginOTP from "../Login/components/LoginOTP";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //marginBottom: 40,

  },
  rootXS: {
    display: "flex",
    position: "relative",
    //minheight: "180vh",
    height: "100%",
  },
  appBar: {
    background:
      "transparent linear-gradient(165deg, #FFC20E 0%, #FEE802 66%, #FEEC01 77%, #FDDB07 86%, #F7941E 100%) 0% 0% no-repeat padding-box",
    boxShadow: "0 0 15px 0 rgba(0, 0, 0, 0.1)",
    height: 90,
  },
  appBarEnrolGiro: {
    background: "#333333",
    boxShadow: "0 0 15px 0 rgba(0, 0, 0, 0.1)",
    height: 90,
  },
  appBarEnrolGiroIsLogin: {
    background:
      "transparent linear-gradient(143deg, #004880 0%, #0066A7 31%,#007F9C 59%,#008992 80%,#00FFAF 100%) 0% 0% no-repeat padding-box",
    boxShadow: "0 0 15px 0 rgba(0, 0, 0, 0.1)",
    height: 90,
  },
  toolbarStyle: {
    flexGrow: 1,
  },
}));

const MainRoutes = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));
  // const { pathname } = useLocation();
  const { path, url } = useRouteMatch();
  const [isLogin, setIsLogin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    console.log("dependencies", dependencies, version)

    AuthManager.retrieveToken().then((value) => {
      if (value) {
        setIsLogin(true);
        localStorage.setItem("EnrolGiroFooter", "false");
        console.log("a");
      } else {
        localStorage.setItem("EnrolGiroFooter", "true");
      }
    });

    // Specify how to clean up after this effect:
    return () => { };
  }, []);

  useEffect(() => {
    // ReactGA.initialize(process.env.REACT_APP_GA_ID);
    // // if (location.pathname === "/OnlineRenewal") {
    // //   //To report Page View
    // //   ReactGA.pageview(window.location.pathname + window.location.search);
    // // }
    // ReactGA.pageview(window.location.pathname + window.location.search);
  });

  return (
    <div>
      {matchesXS ? (
        <div className={classes.rootXS}>
          {matchesXS && location.pathname !== "/MovieEvent" ? (
            <AppBar
              position="fixed"
              className={
                location.pathname === "/EnrolGiro" ||
                  location.pathname === "/enrolgiro" ||
                  location.pathname === "/EnrolGiroInfo" ||
                  location.pathname === "/GiroStatus" ||
                  location.pathname === "/GiroProcess" ||
                  location.pathname === "/GiroReview"
                  ? isLogin
                    ? classes.appBarEnrolGiroIsLogin
                    : classes.appBarEnrolGiro
                  : classes.appBar
              }
            >
              <Toolbar className={classes.toolbarStyle}>
                <img
                  src={
                    location.pathname === "/EnrolGiro" ||
                      location.pathname === "/enrolgiro" ||
                      location.pathname === "/EnrolGiroInfo" ||
                      location.pathname === "/GiroStatus" ||
                      location.pathname === "/GiroProcess" ||
                      location.pathname === "/GiroReview"
                      ? isLogin
                        ? Image.tiqconnectLogo
                        : Image.nonDirectClientEtiqaLogo
                      : Image.directClientEtiqaLogoNew
                  }
                  style={{ width: 154, height: 100 }}
                />
              </Toolbar>
            </AppBar>
          ) : (
            false
          )}

          <Switch>
            <Redirect from="//*//*" to="/*/*" />
            <Route exact path="/">
              {/*<OnlineRenewal/>*/}
              <Login matchesXS={matchesXS} />
              <OnboardingFlow />
            </Route>
            <Route exact path="/Login">
              {/*<OnlineRenewal/>*/}
              <Login matchesXS={matchesXS} />
              {/* <OnboardingFlow /> */}
            </Route>
            <Route relative path="/ForgotUserID">
              <ForgotUserID />
            </Route>
            <Route exact path="/GetCurrentUserOTP">
              <ForgotUserIdOtp />
            </Route>
            <Route exact path="/ForgotPasswordOTP">
              <ForgotUserPassOtp />
            </Route>
            <Route exact path="/ReceivedUserID">
              <ReceivedUserID />
            </Route>
            <Route exact path="/ForgotPassword">
              <ForgotPassword />
            </Route>
            <Route exact path="/EnterNewPassword">
              <NewPassword />
            </Route>
            <Route exact path="/ChangedPassword">
              <ChangedPassword />
            </Route>
            <Route exact path="/Registration">
              {/* <Registration /> */}
              <RetrieveOptionFir />
            </Route>
            <Route exact path="/OnboardingSPLanding">
              {/* <Registration /> */}
              <SPLanding />
            </Route>
            <Route exact path="/OnboardingLanding">
              {/* <Registration /> */}
              {/* <NormalReg/> */}
              <NormalRegNew />
              {/* <IdentityVerification/> */}
            </Route>
            <Route exact path="/OnboardingErr">
              {/* <Registration /> */}
              {/* <NormalReg/> */}
              <SomethingWrong />
              {/* <IdentityVerification/> */}
            </Route>
            <Route exact path="/CreateUserIDPass">
              {/* <Registration /> */}
              {/* <NormalReg/> */}
              <CreateUserIDPass />
              {/* <IdentityVerification/> */}
            </Route>
            <Route exact path="/IdentityVerification">
              {/* <Registration /> */}
              {/* <NormalReg/> */}
              {/* <NormalRegNew/> */}
              <IdentityVerification />
            </Route>
            <Route exact path="/MobileVerification">
              <MobileVerification />
            </Route>
            <Route exact path="/RegistrationOtp">
              {/* <RegistrationOtp /> */}
              <MobileOtpNew />
            </Route>
            <Route exact path="/OnlineRenewal">
              <OnlineRenewal />
            </Route>
            <Route exact path="/CheckRenewability">
              <CheckRewability />
            </Route>
            <Route exact path="/PolicyInfo">
              <PolicyInfo />
            </Route>
            <Route exact path="/RenewalUnsuccessful">
              <RenewalUnsuccessful />
            </Route>
            <Route exact path="/PayRenewalUnsuccessful">
              <PayRenewalUnsuccessful />
            </Route>
            <Route exact path="/Paymentstatus">
              <PaymentResult />
            </Route>
            <Route exact path="/AuthorizationMaybank">
              <AuthorizationMaybank />
            </Route>
            <Route exact path="/ActivationGenericLink">
              <ActivationGenericLink />
            </Route>
            <Route exact path="/ActivationPersonalLink">
              <ActivationPersonalLink />
            </Route>
            <Route exact path="/ActivationGenericOTP">
              <ActivationGenericOtpVerify />
            </Route>
            <Route exact path="/ActivationPersonalOTP">
              <ActivationPersonalOtpVerify />
            </Route>
            <Route exact path="/ReceivedGenericLinkOTP">
              <ReceivedGenericLinkOtp />
            </Route>
            <Route exact path="/ReceivedPersoanlLinkOTP">
              <ReceivedPersoanlLinkOtp />
            </Route>

            <Route exact path="/LiveChat">
              <LiveChat />
            </Route>

            {/* <Route exact path="/UpdateClientInfo" >
          <Registrationv1 />
        </Route> */}
            <Route exact path="/AccountExist">
              <AccountExist />
              {/* <ReceivedRequest /> */}
              {/* <SomethingWrong /> */}
              {/* <CreateUserIDPass /> */}
            </Route>
            <Route exact path="/ExistingAcc">
              <ExistingAcc />
            </Route>
            <Route exact path="/ReceivedRequest">

              <ReceivedRequest />
              {/* <SomethingWrong /> */}
              {/* <CreateUserIDPass /> */}
            </Route>
            <Route exact path="/MobileNoRequired">
              <MobileNoRequired />
            </Route>
            <Route exact path="/SingpassRedirect">
              <SingpassRedirectPage />
            </Route>
            <Route exact path="/EnrolGiro">
              <EnrolGiroNow />
            </Route>
            <Route exact path="/EnrolGiroInfo">
              <EnrolGiroInfo />
            </Route>
            <Route exact path="/SelectEnrolmentAccount">
              <SelectEnrolmentAccount />
            </Route>
            <Route exact path="/GiroStatus">
              <EnrolmentStatus />
            </Route>
            <Route exact path="/GiroProcess">
              <GiroProcess />
            </Route>
            <Route exact path="/FileManager">
              <FileManager />
            </Route>
            <Route exact path="/DDAMissMatch">
              <DDAMissMatch />
            </Route>
            <Route exact path="/DDAMissMatchNo">
              <DDAMissMatchNo />
            </Route>
            <Route exact path="/DDAMissMatchYes">
              <DDAMissMatchYes />
            </Route>
            <Route exact path="/GiroReview">
              <GiroReview />
            </Route>
            <Route exact path="/ProcessSubmitStatus">
              <ProcessSubmitStatus />
            </Route>
            <Route exact path="/SingtelLeads">
              <SingtelLeads />
            </Route>
            {/* <Route exact path="/WalkWithPets/registration">
              <WalkAndWag />
            </Route>*/}
            <Route exact path="/ENOB">
              <LandingPage />
            </Route>

            <Route exact path="/Onboarding">
              <OnboardingFlow />
            </Route>

            <Route exact path="/PolicyRedirection">
              <PolicyRedirection />
            </Route>

            <Route exact path="/LoginOTP">
              <LoginOTP />
            </Route>
            {/* <Route exact path="/MovieEvent">
              <MovieEvent />
            </Route> */}

            {/* <Route exact path="/prototype/test">
          <CustomBoard/>
        </Route> */}
          </Switch>
          {location.pathname === "/MovieEvent" ? (
            <FooterMovieEvent open={false} />
          ) : (
            <Footer
              open={false}
              EnrolGiroFooter={localStorage.getItem("EnrolGiroFooter")}
            />
          )}
        </div>
      ) : (
        <div className={classes.root}>
          {matchesXS ? (
            <AppBar position="fixed" className={classes.appBar}>
              <Toolbar className={classes.toolbarStyle}>
                <img
                  src={Image.directClientEtiqaLogo}
                  style={{ width: 154, height: 56 }}
                />
              </Toolbar>
            </AppBar>
          ) : (
            false
          )}

          <Switch>
            <Redirect from={`${path}//:`} to={`${path}/:`} />
            <Route exact path="/">
              {/*<OnlineRenewal/>*/}
              <Login matchesXS={matchesXS} />
              {/* <OnboardingFlow /> */}
            </Route>
            <Route exact path="/Login">
              {/*<OnlineRenewal/>*/}
              <Login matchesXS={matchesXS} />
              {/* <OnboardingFlow /> */}
            </Route>
            <Route relative path="/ForgotUserID">
              <ForgotUserID />
            </Route>
            <Route exact path="/GetCurrentUserOTP">
              <ForgotUserIdOtp />
            </Route>
            <Route exact path="/ForgotPasswordOTP">
              <ForgotUserPassOtp />
            </Route>
            <Route exact path="/ReceivedUserID">
              <ReceivedUserID />
            </Route>
            <Route exact path="/ForgotPassword">
              <ForgotPassword />
            </Route>
            <Route exact path="/EnterNewPassword">
              <NewPassword />
            </Route>
            <Route exact path="/ChangedPassword">
              <ChangedPassword />
            </Route>
            <Route exact path="/Registration">
              {/* <Registration /> */}
              <RetrieveOptionFir />
            </Route>
            <Route exact path="/OnboardingSPLanding">
              {/* <Registration /> */}
              <SPLanding />
            </Route>
            <Route exact path="/OnboardingLanding">
              {/* <Registration /> */}
              {/* <NormalReg/> */}
              <NormalRegNew />
              {/* <IdentityVerification/> */}
            </Route>
            <Route exact path="/OnboardingErr">
              {/* <Registration /> */}
              {/* <NormalReg/> */}
              <SomethingWrong />
              {/* <IdentityVerification/> */}
            </Route>
            <Route exact path="/CreateUserIDPass">
              {/* <Registration /> */}
              {/* <NormalReg/> */}
              <CreateUserIDPass />
              {/* <IdentityVerification/> */}
            </Route>
            <Route exact path="/IdentityVerification">
              {/* <Registration /> */}
              {/* <NormalReg/> */}
              {/* <NormalRegNew/> */}
              <IdentityVerification />
            </Route>
            <Route exact path="/MobileVerification">
              <MobileVerification />
            </Route>
            <Route exact path="/RegistrationOtp">
              {/* <RegistrationOtp /> */}
              <MobileOtpNew />
            </Route>
            <Route exact path="/OnlineRenewal">
              <OnlineRenewal />
            </Route>
            <Route exact path="/CheckRenewability">
              <CheckRewability />
            </Route>
            <Route exact path="/PolicyInfo">
              <PolicyInfo />
            </Route>
            <Route exact path="/RenewalUnsuccessful">
              <RenewalUnsuccessful />
            </Route>
            <Route exact path="/PayRenewalUnsuccessful">
              <PayRenewalUnsuccessful />
            </Route>
            <Route exact path="/Paymentstatus">
              <PaymentResult />
            </Route>
            <Route exact path="/AuthorizationMaybank">
              <AuthorizationMaybank />
            </Route>
            <Route exact path="/ActivationGenericLink">
              <ActivationGenericLink />
            </Route>
            <Route exact path="/ActivationPersonalLink">
              <ActivationPersonalLink />
            </Route>
            <Route exact path="/ActivationGenericOTP">
              <ActivationGenericOtpVerify />
            </Route>
            <Route exact path="/ActivationPersonalOTP">
              <ActivationPersonalOtpVerify />
            </Route>
            <Route exact path="/ReceivedGenericLinkOTP">
              <ReceivedGenericLinkOtp />
            </Route>
            <Route exact path="/ReceivedPersoanlLinkOTP">
              <ReceivedPersoanlLinkOtp />
            </Route>
            {/* <Route exact path="/UpdateClientInfo" >
          <Registrationv1 />
        </Route> */}
            <Route exact path="/AccountExist">
              <AccountExist />
              {/* <ReceivedRequest /> */}
              {/* <SomethingWrong /> */}
              {/* <CreateUserIDPass /> */}
            </Route>
            <Route exact path="/ExistingAcc">
              <ExistingAcc />
            </Route>
            <Route exact path="/ReceivedRequest">
              {/* <AccountExist /> */}
              <ReceivedRequest />
              {/* <SomethingWrong /> */}
              {/* <CreateUserIDPass /> */}
            </Route>
            <Route exact path="/MobileNoRequired">
              <MobileNoRequired />
            </Route>
            <Route exact path="/SingpassRedirect">
              <SingpassRedirectPage />
            </Route>
            <Route exact path="/EnrolGiro">
              <EnrolGiroNow />
            </Route>
            <Route exact path="/EnrolGiroInfo">
              <EnrolGiroInfo />
            </Route>
            <Route exact path="/SelectEnrolmentAccount">
              <SelectEnrolmentAccount />
            </Route>
            <Route exact path="/GiroStatus">
              <EnrolmentStatus />
            </Route>
            <Route exact path="/GiroProcess">
              <GiroProcess />
            </Route>
            <Route exact path="/DDAResponseStatus">
              <DDAResponseStatus />
            </Route>
            <Route exact path="/DDAMissMatch">
              <DDAMissMatch />
            </Route>
            <Route exact path="/DDAMissMatchNo">
              <DDAMissMatchNo />
            </Route>
            <Route exact path="/DDAMissMatchYes">
              <DDAMissMatchYes />
            </Route>
            <Route exact path="/FileManager">
              <FileManager />
            </Route>
            <Route exact path="/GiroReview">
              <GiroReview />
            </Route>
            <Route exact path="/ProcessSubmitStatus">
              <ProcessSubmitStatus />
            </Route>

            <Route exact path="/LiveChat">
              <LiveChat />
            </Route>
            <Route exact path="/SingtelLeads">
              <SingtelLeads />
            </Route>
            {/* <Route exact path="/WalkWithPets/registration">
              <WalkAndWag />
            </Route>*/}
            <Route exact path="/ENOB">
              <LandingPage />
            </Route>

            <Route exact path="/Onboarding">
              <OnboardingFlow />
            </Route>

            <Route exact path="/PolicyRedirection">
              <PolicyRedirection />
            </Route>

            <Route exact path="/LoginOTP">
              <LoginOTP />
            </Route>

            {/* <Route exact path="/MovieEvent">
              <MovieEvent />
            </Route> */}

            {/* <Route exact path="/prototype/test">
          <CustomBoard/>
        </Route> */}
          </Switch>
          {/* <Footer
            open={true}
            EnrolGiroFooter={localStorage.getItem("EnrolGiroFooter")}
          /> */}
          {location.pathname === "/MovieEvent" ? (
            <FooterMovieEvent open={true} />
          ) : (
            <Footer
              open={true}
              EnrolGiroFooter={localStorage.getItem("EnrolGiroFooter")}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default withRouter(MainRoutes);
